'use strict';

var _ = require('underscore'),
  Backbone = require('backbone'),

  MegaMenuItemCollection = Backbone.Collection.extend({
    parse: function(response) {
      return response.data;
    },
    initialize: function(options) {
      _.extend(this, options);
    }
  });

module.exports = MegaMenuItemCollection;



// WEBPACK FOOTER //
// ./assets/components/MegaMenuAjaxList/MegaMenuItemCollection.js